import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styles from './ProductUSPs.module.scss';

interface IProductUSPs {
  uniqueSellingPoints: {
    code: string;
    value: string;
  }[];
}

export const ProductUSPs = ({ uniqueSellingPoints }: IProductUSPs) => {
  const { t } = useTranslation('product-details');
  return (
    <>
      <h3 className="h2 mb-2">{t('title.unique-selling-points')}</h3>
      <ul className={styles.list}>
        {uniqueSellingPoints.map((usp) => (
          <li className={styles.plusCircle} key={usp.value}>
            {usp.value}
          </li>
        ))}
      </ul>
    </>
  );
};
